var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "div",
          { staticClass: "filter-content" },
          [
            _vm.element.component && _vm.element.component !== "de-date"
              ? _c("el-card", { staticClass: "box-card" }, [
                  _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("dynamic_time.set_default"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "custom-component-class" },
                    [
                      _c(_vm.element.component, {
                        tag: "component",
                        staticClass: "component",
                        style: _vm.element.style,
                        attrs: {
                          id: "component" + _vm.element.id,
                          element: _vm.element,
                          "in-draw": false,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.element.component &&
            _vm.element.component === "de-date" &&
            _vm.element.serviceName &&
            _vm.element.serviceName !== "timeDateRangeWidget"
              ? _c(
                  "el-card",
                  { staticClass: "box-card" },
                  [
                    _vm.element.component === "de-date" &&
                    _vm.element.serviceName !== "timeDateRangeWidget"
                      ? _c("de-date-default", {
                          attrs: { element: _vm.element },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.element.component &&
            _vm.element.component === "de-date" &&
            _vm.element.serviceName &&
            _vm.element.serviceName === "timeDateRangeWidget"
              ? _c(
                  "el-card",
                  { staticClass: "box-card" },
                  [
                    _vm.element.component === "de-date" &&
                    _vm.element.serviceName === "timeDateRangeWidget"
                      ? _c("de-date-range-default", {
                          attrs: { element: _vm.element },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }